import React from 'react';
//import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import _ from 'lodash';
import * as MODEL from '~/constants/ModelConstants';
import * as searchActions from '~/search2/actions';
type CSFilterItemProps = {
  actions: object;
  name: string;
  value: string;
  title: string;
  refFunc: (...args: any[]) => any;
  searchDataState: object;
};
class CSFilterItem extends React.Component<CSFilterItemProps, {}> {
  updateFilter = (k, v) => {
    this.props.actions.setFilter(k, v);
  };
  render() {
    const { name, value, title, refFunc } = this.props;
    const { filters } = this.props.searchDataState;
    const filterTypeUsed = type => filters.type && filters.type.indexOf(type) !== -1;
    const libraryOnlyNames = ['license', 'vulnerable', 'source']; // 'vulnerabilities' as in a library WITH vulns
    const vulnOnlyNames = ['severity', 'vulnerable_method', 'enhanced', 'cve', 'exploits'];
    const languageToSourceMap = MODEL.languageToSourceMap;
    let disabled = false;
    // if they only want to see vulnerability records then disable library only fields
    if (filterTypeUsed('vulnerability') && _.includes(libraryOnlyNames, name)) {
      disabled = true;
    }
    // if they only want to see library records then disable vuln only fields
    if (filterTypeUsed('library') && _.includes(vulnOnlyNames, name)) {
      disabled = true;
    }
    // Disable source based on language selection
    if (filters.language !== 'all' && !_.isEmpty(filters.language) && name === 'source') {
      disabled = false;
      _.each(languageToSourceMap, function(source, language) {
        if (_.includes(source, value)) {
          if (_.includes(filters.language, language)) {
            disabled = false;
            return false; // Equivalent to break;
          } else {
            disabled = true;
          }
        }
      });
    }
    const labelClasses = classNames({
      'position--relative': true,
      'color--muted-light': disabled,
    });
    return (
      <label className={labelClasses}>
        <input
          type="checkbox"
          name={name}
          value={value}
          ref={refFunc}
          onClick={this.updateFilter.bind(this, name, value)}
          disabled={disabled}
        />
        <span className="control--checkbox" />
        {title}
      </label>
    );
  }
}
function mapStateToProps(state) {
  return {
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(searchActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSFilterItem);
